import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import { request } from "@/js/http/http_request";
import { getTokens } from "@/js/consent";
import { getUserGroupFromToken, isAdminNotConsultant, isTokenExpired, cleanStorageLogin } from "@/js/http/auth";
import { clearAllFilters } from "@/js/filter/filter.js";
import { setCurrencyUsedForCartAndExplore, getCurrencyUser } from "@/js/currency/currencies.js";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "login",
  data: function data() {
    return {
      isShowPassword: false,
      isLoading: false,
      loginError: "",
      passwordError: "",
      captchaError: "",
      errorMessages: {
        login: {
          empty: "Please enter a username"
        },
        password: {
          empty: "Please enter a password",
          unknown: "Incorrect username or password"
        },
        state: {
          different: "Disparities in the verification code of the request. Please contact an administrator as soon as possible"
        },
        captcha: {
          empty: "To confirm that you are not an automated system, please complete the CAPTCHA verification."
        }
      },
      input: {
        login: "",
        password: "",
        client_id: this.$whitelabel.clientId,
        client_secret: this.$whitelabel.clientSecret,
        grant_type: "code",
        state: process.env.VUE_APP_STATE,
        consent: true,
        captchaToken: ""
      },
      isCaptchaEnabled: false,
      captchaToken: ""
    };
  },
  components: {
    VueHcaptcha: VueHcaptcha,
    BackgroundVideo: BackgroundVideo
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isTokenExpired()) {
              _this2.$router.push({
                name: "userHome"
              });
            }
            _this2.isLoading = true;
            _context.next = 4;
            return request("/v1/gate/authorize/trusted", "post", _this2.input, false, "cap").then(function (response) {
              _this2.isCaptchaEnabled = response.data;
            });
          case 4:
            _this2.isLoading = false;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    hCaptchaSiteKey: function hCaptchaSiteKey() {
      return process.env.VUE_APP_HCAPTCHA_SITE_KEY;
    }
  },
  methods: {
    generateGUID: function generateGUID() {
      return crypto.randomUUID();
    },
    login: function login() {
      this.isLoading = true;
      var valid = this.validateInputs();
      if (this.isCaptchaEnabled & !this.input.captchaToken) {
        this.captchaError = this.errorMessages.captcha.empty;
        this.isLoading = false;
        return;
      }
      if (valid) {
        var _this = this;
        this.generateGUID();
        request("/v1/gate/authorize", "post", _this.input, false, "cap").then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(response) {
            var isWizardDisplayed;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(response.data.state != _this.input.state)) {
                    _context2.next = 4;
                    break;
                  }
                  // TODO gérer mieux que ça cette erreur de state différent
                  _this.passwordError = _this.errorMessages.state.different;
                  _context2.next = 13;
                  break;
                case 4:
                  if (!(response.status == 200)) {
                    _context2.next = 11;
                    break;
                  }
                  _context2.next = 7;
                  return getTokens(_this, response.data.code, response.data.state, _this.input.client_id, _this.input.client_secret);
                case 7:
                  isWizardDisplayed = !response.data.is_each_term_accepted || response.data.first_connection;
                  if (isWizardDisplayed) {
                    _this.$router.push({
                      name: "accept-terms",
                      query: {
                        is_first_connection: response.data.first_connection
                      }
                    });
                  } else {
                    getCurrencyUser().then(function (response) {
                      if (response.status == 200) {
                        cleanStorageLogin();
                        setCurrencyUsedForCartAndExplore(response.data.currency);
                        var redirect = _this.$route.query.redirect;
                        if (redirect) {
                          _this.$router.push(decodeURIComponent(redirect));
                        } else {
                          var urlRedirection = _this.$whitelabel.routeAfterLogin;
                          if (urlRedirection === "wineList" || urlRedirection === "productList") {
                            var userGroup = getUserGroupFromToken();
                            switch (userGroup) {
                              case "USER":
                              case "HORECA":
                              case "WHOLESALER":
                                urlRedirection = "userProductList";
                                break;
                              case "ADMIN":
                                urlRedirection = "adminProductList";
                                break;
                            }
                          }
                          _this.$router.push({
                            name: urlRedirection
                          }).catch(function () {});
                        }
                      }
                    });
                  }
                  _context2.next = 13;
                  break;
                case 11:
                  _this.isLoading = false;
                  _this.passwordError = _this.errorMessages.password.unknown;
                case 13:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (e) {
          var _e$response;
          _this.isLoading = false;
          if (_this.isCaptchaEnabled) {
            _this.$refs.hCaptchaRef.reset();
            _this.input.captchaToken = "";
          }
          _this.isCaptchaEnabled = (e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.attempts) > 3 ? true : false;
          _this.passwordError = _this.errorMessages.password.unknown;
        });
      } else {
        this.isLoading = false;
      }
    },
    create: function create() {
      var utm_source = this.$route.query.utm_source;
      if (utm_source) {
        this.$router.push({
          name: "subscribe",
          query: {
            utm_source: utm_source
          }
        });
      } else {
        this.$router.push({
          name: "subscribe"
        });
      }
    },
    validateInputs: function validateInputs() {
      this.loginError = "";
      this.passwordError = "";
      if (this.input.login == "") {
        this.loginError = this.errorMessages.login.empty;
      }
      if (this.input.password == "") {
        this.passwordError = this.errorMessages.password.empty;
      }
      if (this.loginError == "" && this.passwordError == "") {
        return true;
      }
      return false;
    },
    resetPassword: function resetPassword() {
      this.$router.push({
        name: "reset"
      });
    },
    captchaVerifiedCallback: function captchaVerifiedCallback(token) {
      this.input.captchaToken = token;
      if (this.input.captchaToken) this.captchaError = "";
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!isTokenExpired() && !isAdminNotConsultant()) {
      clearAllFilters();
    }
    next();
  }
};